import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router'

const useScrollTop = () => {
  const { search: searchQuery, state: locationState } = useLocation<{
    scrollTop?: boolean
  }>()

  const prevSearchQuery = useRef(searchQuery)

  useEffect(() => {
    if (locationState?.scrollTop) {
      window.scrollTo(0, 0)
    }
  }, [locationState])

  useEffect(() => {
    if (searchQuery !== prevSearchQuery.current) {
      window.scrollTo(0, 0)
    }
  }, [searchQuery])
}

export default useScrollTop
